import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { GetAllReportProvvedimentiFiltersDTO, GetAllReportProvvedimentiResponseData } from "./dataService/dto";
import { ReportProvvedimentiService, NewReportProvvedimentiService } from "./dataService/service";

interface ReportProvvedimentiState {
    // FILTERS
    GetAllReportProvvedimentiFilters: GetAllReportProvvedimentiFiltersDTO
    GetAllReportProvvedimentiStatus: PromiseStatuses
    GetAllReportProvvedimentiResponse?: GetAllReportProvvedimentiResponseData[]

}

const initialState: ReportProvvedimentiState = {

    GetAllReportProvvedimentiFilters: {
        itemsPerPage: 500,
        page: 0
    },

    GetAllReportProvvedimentiStatus: 'idle',
}

export const GetAllReportProvvedimenti = createAsyncThunk(
    'monitoringM24Open/GetAllReportProvvedimenti',
    async (filters: GetAllReportProvvedimentiFiltersDTO, thunkApi): Promise<GetAllReportProvvedimentiResponseData[]> => {
        const ReportProvvedimentiService = NewReportProvvedimentiService()

        return ReportProvvedimentiService.GetAllReportProvvedimenti(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const ReportProvvedimentiSlice = createSlice({
    name: 'ReportProvvedimentiSlice/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllReportProvvedimentiFiltersItemsPerPage: (state, action) => {
            state.GetAllReportProvvedimentiFilters.itemsPerPage = action.payload
        },
        setGetAllReportProvvedimentiFiltersPage: (state, action) => {
            state.GetAllReportProvvedimentiFilters.page = action.payload
        },
        setGetAllReportProvvedimentiFiltersOrder: (state, action) => {
            state.GetAllReportProvvedimentiFilters.order = action.payload
        },
        setGetAllReportProvvedimentiFiltersSort: (state, action) => {
            state.GetAllReportProvvedimentiFilters.sort = action.payload
        },
        setGetAllReportProvvedimentiStartingDate: (state, action) => {
            state.GetAllReportProvvedimentiFilters.from = action.payload
        },
        setGetAllReportProvvedimentiYear: (state, action) => {
            state.GetAllReportProvvedimentiFilters.year = action.payload
        },
        setGetAllReportProvvedimentiRegion: (state, action) => {
            state.GetAllReportProvvedimentiFilters.region = action.payload
        },
        setGetAllReportProvvedimentiSot: (state, action) => {
            state.GetAllReportProvvedimentiFilters.sot = action.payload
        },
        setGetAllFaseAvvioEndingDate: (state, action) => {
            state.GetAllReportProvvedimentiFilters.to = action.payload
        },
        resetGetAllReportProvvedimentiFilters: (state) => {
            state.GetAllReportProvvedimentiFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllReportProvvedimenti.pending, (state) => {
                state.GetAllReportProvvedimentiStatus = 'loading'
            })
            .addCase(GetAllReportProvvedimenti.fulfilled, (state, action) => {
                state.GetAllReportProvvedimentiStatus = 'successfully'
                state.GetAllReportProvvedimentiResponse = action.payload
            })
            .addCase(GetAllReportProvvedimenti.rejected, (state) => {
                state.GetAllReportProvvedimentiStatus = 'failed'
            })

    },
})

export const {
    setGetAllFaseAvvioEndingDate,
    setGetAllReportProvvedimentiStartingDate,
    setGetAllReportProvvedimentiFiltersItemsPerPage,
    setGetAllReportProvvedimentiRegion,
    setGetAllReportProvvedimentiSot,
    setGetAllReportProvvedimentiFiltersOrder,
    setGetAllReportProvvedimentiFiltersPage,
    setGetAllReportProvvedimentiFiltersSort,
    setGetAllReportProvvedimentiYear,
    resetGetAllReportProvvedimentiFilters
} = ReportProvvedimentiSlice.actions

export default ReportProvvedimentiSlice.reducer